import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {isAdminGuard} from './core/guards/isAdmin.guard';
import {hasRoleGuard} from './core/guards/role.guard';
import {PLAYER_SPACE_ROLES, RolesEnum} from './core/models/user/roles.enum';

const routes: Routes = [
  {
    path: 'public',
    loadChildren: () => import('./modules/public/public.module').then(m => m.PublicModule)
  },
  {
    path: 'app',
    loadChildren: () => import('./modules/player/player.module').then(m => m.PlayerModule),
    canActivate: [hasRoleGuard(PLAYER_SPACE_ROLES)],
  },
  {
    path: 'game',
    loadChildren: () => import('./modules/game/game.module').then(m => m.GameModule),
  },
  {
    path: 'admin',
    loadChildren: () => import('./modules/admin/admin.module').then(m => m.AdminModule),
    canActivate: [isAdminGuard()]
  },
  {
    path: 'operator',
    loadChildren: () => import('./modules/operator/operator.module').then(m => m.OperatorModule),
    canActivate: [hasRoleGuard([RolesEnum.ROLE_OPERATOR])]
  },
  {
    // Page publique de projection grand écran. Accessible sans session,
    // sécurité par token JWT court-vie dans le query param `t`.
    path: 'wall/:eventId',
    loadComponent: () => import('./modules/wall/wall.page').then(m => m.WallPage),
    title: 'Wheriz | Projection',
  },
  {path: '', redirectTo: 'public', pathMatch: 'full'},
  {
    path: '**',
    redirectTo: 'public',
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { bindToComponentInputs: true, paramsInheritanceStrategy: 'always' })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
